import React from 'react';

import * as colors from '../../../../Util/Colors';
import {
  formatMetricName,
  getBenchmarkSuffix,
  parseTrendFixedString,
} from './helper';

import { isConstructorDeclaration } from 'typescript';
import { useIntl } from 'react-intl';
import { getMetricStringIdAndDefaultMessage } from '../LighthouseMetrics/helper';
import {
  MetricBooleanMap,
  parseFixedString,
  PERCENTAGE_TABLE,
} from '../../../Dashboard/DashboardComponents/LighthouseMetrics/helper';

const CustomTooltipTrends = ({
  active,
  payload,
  separator,
  formatter,
  itemStyle,
}: any): React.ReactElement | null => {
  const intl = useIntl();
  if (!active) {
    return null;
  }
  const listStyle = {
    padding: 8,
    margin: 0,
    backgroundColor: '#FFF',
    border: '1px solid #008080',
    borderRadius: 4,
  };

  if (payload === null || payload.length === 0) {
    return null;
  }

  const items = payload
    .reverse()
    .map((entry: any, i: number): React.ReactElement | null => {
      if (entry.type === 'none' || entry.name === 'none') {
        return null;
      }

      const isPercentage =
        entry && entry.name
          ? PERCENTAGE_TABLE[
              (entry.name || '').replace(
                /#netavg/gi,
                ''
              ) as keyof MetricBooleanMap
            ]
          : false;

      const finalItemStyle = {
        display: 'block',
        paddingTop: 4,
        paddingBottom: 4,
        color: colors.primaryStroke,
        ...itemStyle,
      };
      const finalFormatter = entry.formatter || formatter;
      let { name, value } = entry;
      if (finalFormatter) {
        const formatted = finalFormatter(value, name, entry, i, payload);
        if (Array.isArray(formatted)) {
          [value, name] = formatted;
        } else {
          value = formatted;
        }
      }
      if (Number.isNaN(value)) {
        return null;
      }
      return value !== 'null' ? (
        <li
          className='recharts-tooltip-item'
          // eslint-disable-next-line react/no-array-index-key
          key={`tooltip-item-${i}`}
          style={finalItemStyle}
        >
          <span className='recharts-tooltip-item-name'>
            {intl.formatMessage({
              ...getMetricStringIdAndDefaultMessage(
                name.replace('#netavg', '').toUpperCase()
              ),
            }) + getBenchmarkSuffix(name)}
          </span>

          <span className='recharts-tooltip-item-separator'>{separator}</span>

          <span className='recharts-tooltip-item-value'>
            {parseTrendFixedString(parseFloat(value), isPercentage, true)}
          </span>
          <span className='recharts-tooltip-item-unit'>
            {isPercentage ? '%' : null}
          </span>
        </li>
      ) : null;
    })
    .filter((entry: React.ReactElement | null) => entry !== null);

  if (items.length === 0) {
    return null;
  }

  return (
    <ul className='recharts-tooltip-item-list' style={listStyle}>
      {items}
    </ul>
  );
};

export default CustomTooltipTrends;
